module.exports = __webpack_public_path__ + "static/profile_photo_placeholder-5e5c2ab4bf937f921fae192f2933a0fe.png";